import api from '@/services/api';
import { authService } from '@/services/authService';
import { usuarioService } from '@/services/usuarioService';
import router from '../../router';
import { LOCAL_STORAGE_PREFIX } from '../../utils/utils';

const state = {
  usuario: null,
  timeout_refresh: null,
  token: {
    id_licenca: null,
    access_token: null,
    refresh_token: null,
  },
  tokens: [],
  usuario_licenca: null,
  usuario_licencas: []
}

const getters = {
  usuario: state => state.usuario,
  access_token: state => state.token.access_token,
  refresh_token: state => state.token.refresh_token,
  usuario_licenca: state => state.usuario_licenca,
  usuario_licencas: state => state.usuario_licencas,
  usuario_tokens: state => state.tokens,
  isAdmin: state => state.usuario ? state.usuario.tipo === 'admin' : false,
  isLoggedIn: state => !!(state.usuario && state.token.access_token)
}

const actions = {
  async login({ state, commit, dispatch }, { email, senha, id_licenca }) {
    commit('SET_LOADING', true);
    clearTimeout(state.timeout_refresh);
    try {
      const response = await authService.login(email, senha, id_licenca);
      const { token, usuario, licenca, licencas } = response.data;

      if (licencas && licencas.length) {
        // Se existir a variável licencas, quer dizer que o usuário
        // tem mais de 1 licença para esse aplicativo, nesse caso
        // será adicionado as licenças no estado e será mostrado uma tela
        // de seleção da licença que o usuário quer fazer o login
        commit('SET_USUARIO_LICENCAS', licencas);
        commit('SET_LOADING', false);
        return;
      }

      // login successful if there's a jwt token in the response
      if (token.access_token) {
        // create axios default header authorization for requests
        api.defaults.headers.common['Authorization'] = `Bearer ${token.access_token}`;
      }
      commit('SET_TOKEN', { id_licenca: licenca.id_licenca, licenca: licenca.titulo, access_token: token.access_token, refresh_token: token.refresh_token });
      commit('SET_USUARIO_LOGIN', usuario);
      commit('SET_USUARIO_LICENCA', licenca);
      const twoMinutesBeforeExpires = new Date(token.expiresIn - 120000).getTime() - new Date().getTime();
      state.timeout_refresh = setTimeout(() => {
        // Refresh Token
        dispatch('silentRefresh');
      }, twoMinutesBeforeExpires);
      commit('SHOW_SNACKBAR', { text: `Bem-vindo, ${usuario.nome}!`, status: 'success' });
      commit('SET_LOADING', false);
      // router.push({ name: 'Home' });
      return true;
    } catch (error) {
      const errorMessage = error.response ? error.response.data.error : error.message;
      // commit('LOGIN_FAILURE');
      commit('SHOW_SNACKBAR', { text: errorMessage, status: 'error' });
      commit('SET_LOADING', false);
      return false;
    }
  },
  async silentRefresh({ state, commit, dispatch }, refresh_token) {
    clearTimeout(state.timeout_refresh);
    const refreshToken = refresh_token || state.token.refresh_token;
    try {
      const response = await authService.refreshToken(refreshToken);
      const { token, usuario, licenca } = response.data;
      // login successful if there's a jwt token in the response
      if (token.access_token) {
        // create axios default header authorization for requests
        api.defaults.headers.common['Authorization'] = `Bearer ${token.access_token}`;
      }
      commit('SET_TOKEN', { id_licenca: licenca.id_licenca, licenca: licenca.titulo, access_token: token.access_token, refresh_token: token.refresh_token });
      commit('SET_USUARIO_LOGIN', usuario);
      commit('SET_USUARIO_LICENCA', licenca);
      // commit('setTimeout', token.expiresIn);
      const twoMinutesBeforeExpires = new Date(token.expiresIn - 120000).getTime() - new Date().getTime();
      state.timeout_refresh = setTimeout(() => {
        // Refresh Token
        dispatch('silentRefresh');
      }, twoMinutesBeforeExpires);
      return true;
    } catch (error) {
      const errorMessage = error.response ? error.response.data.error : error.message;
      // commit('LOGIN_FAILURE');
      commit('SHOW_SNACKBAR', { text: errorMessage, status: 'error' });
      dispatch('logout');
      return false;
    }
  },
  async getUsuarioLicencas({ state, commit }) {
    commit('SET_LOADING', true);
    try {
      const response = await usuarioService.getLicencas(state.usuario._id);
      commit('SET_USUARIO_LICENCAS', response.data.data);
      commit('SET_LOADING', false);
    } catch (error) {
      const errorMessage = error.response ? error.response.data.error : error.message;
      commit('SHOW_SNACKBAR', { text: errorMessage, status: 'error' });
      commit('SET_LOADING', false);
    }
  },
  async logout({ state, commit }) {
    try {
      await authService.logout(state.token.refresh_token);
      commit('LOGOUT');
      router.push('/login');
    } catch (error) {
      commit('LOGOUT');
      router.push('/login');
    }
  }
}

const mutations = {
  // Salvar o token juntamente com o id_licenca
  // em um array de tokens para validação do logout por licença
  SET_TOKEN: (state, { id_licenca, licenca, access_token, refresh_token }) => {
    const token = {
      id_licenca,
      licenca,
      access_token,
      refresh_token
    };

    state.token = token;

    // Salva o token da aba atual no sessionStorage para caso o usuário atualize a página (F5)
    sessionStorage.setItem(`${LOCAL_STORAGE_PREFIX}:token`, JSON.stringify(state.token));

    const tokenIndex = state.tokens.findIndex(tokenObj => tokenObj.id_licenca === id_licenca);
    if (tokenIndex !== -1) {
      state.tokens.splice(tokenIndex, 1, token);
      localStorage.setItem(`${LOCAL_STORAGE_PREFIX}:tokens`, JSON.stringify(state.tokens));
    } else {
      state.tokens.push(token);
      localStorage.setItem(`${LOCAL_STORAGE_PREFIX}:tokens`, JSON.stringify(state.tokens));
    }
  },
  SET_USUARIO_TOKENS: (state, tokens) => {
    state.tokens = tokens || [];
    localStorage.setItem(`${LOCAL_STORAGE_PREFIX}:tokens`, JSON.stringify(state.tokens));
  },
  REMOVE_USUARIO_TOKEN: (state, id_licenca) => {
    const tokens = localStorage.getItem(`${LOCAL_STORAGE_PREFIX}:tokens`) && JSON.parse(localStorage.getItem(`${LOCAL_STORAGE_PREFIX}:tokens`));

    if (tokens && tokens.length) {
      state.tokens = tokens.filter(token => token.id_licenca !== id_licenca);
      localStorage.setItem(`${LOCAL_STORAGE_PREFIX}:tokens`, JSON.stringify(state.tokens));
    } else {
      state.tokens = state.tokens.filter(token => token.id_licenca !== id_licenca);
      localStorage.setItem(`${LOCAL_STORAGE_PREFIX}:tokens`, JSON.stringify(state.tokens));
    }
  },
  SET_USUARIO_LOGIN: (state, usuario) => {
    state.usuario = usuario;
  },
  SET_USUARIO_LICENCA: (state, licenca) => {
    state.usuario_licenca = licenca;
  },
  SET_USUARIO_LICENCAS: (state, licencas) => {
    state.usuario_licencas = licencas;
    localStorage.setItem(`${LOCAL_STORAGE_PREFIX}:licencas`, JSON.stringify(state.usuario_licencas));
  },
  LOGIN_FAILURE: (state) => {
    state.usuario = null;
    state.token.access_token = null;
    state.token.refresh_token = null;
    state.tokens = [];
    state.usuario_licenca = null;
    state.usuario_licencas = [];
    clearTimeout(state.timeout_refresh);
  },
  LOGOUT: (state) => {
    const id_licenca = state.usuario_licenca ? state.usuario_licenca.id_licenca : null;
    // const tokens = state.tokens;
    const tokens = localStorage.getItem(`${LOCAL_STORAGE_PREFIX}:tokens`) && JSON.parse(localStorage.getItem(`${LOCAL_STORAGE_PREFIX}:tokens`));

    localStorage.setItem('logout', id_licenca);

    state.usuario = null;
    state.token.access_token = null;
    state.token.refresh_token = null;
    state.tokens = [];
    state.usuario_licenca = null;
    state.usuario_licencas = [];
    clearTimeout(state.timeout_refresh);

    if (tokens && tokens.length === 1) {
      sessionStorage.removeItem(`${LOCAL_STORAGE_PREFIX}:token`);
      localStorage.removeItem(`${LOCAL_STORAGE_PREFIX}:tokens`);
      localStorage.removeItem(`${LOCAL_STORAGE_PREFIX}:licencas`);
    } else if (tokens && tokens.length > 1) {
      const tokenIndex = tokens.findIndex(tokenObj => tokenObj.id_licenca === id_licenca);

      if (tokenIndex !== -1) {
        tokens.splice(tokenIndex, 1);
        sessionStorage.removeItem(`${LOCAL_STORAGE_PREFIX}:token`);
        localStorage.setItem(`${LOCAL_STORAGE_PREFIX}:tokens`, JSON.stringify(tokens));
      } else {
        sessionStorage.removeItem(`${LOCAL_STORAGE_PREFIX}:token`);
        localStorage.removeItem(`${LOCAL_STORAGE_PREFIX}:tokens`);
        localStorage.removeItem(`${LOCAL_STORAGE_PREFIX}:licencas`);
      }
    } else {
      sessionStorage.removeItem(`${LOCAL_STORAGE_PREFIX}:token`);
      localStorage.removeItem(`${LOCAL_STORAGE_PREFIX}:tokens`);
      localStorage.removeItem(`${LOCAL_STORAGE_PREFIX}:licencas`);
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}